<h4 mat-dialog-title>
  {{ 'DIALOG.AUTHENTICATION_ERROR_TITLE' | translate }}
</h4>
<div mat-dialog-content>
  <div>{{ 'DIALOG.AUTHENTICATION_ERROR_BODY' | translate }}</div>
</div>
